module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/4-390002d443de99b8bc27dd3c23fd6e0d.svg";